export type Color =
  | 'blue'
  | 'gray'
  | 'cyan'
  | 'cool-gray'
  | 'green'
  | 'magenta'
  | 'purple'
  | 'red'
  | 'teal'
  | 'yellow';

export const ALL_COLORS: Color[] = [
  'blue',
  'gray',
  'cyan',
  'cool-gray',
  'green',
  'magenta',
  'purple',
  'red',
  'teal',
  'yellow',
];

/* NOTE:: Do not add  yellow or teal to available colors */
export const AVAILABLE_SPACE_COLORS: Color[] = [
  'blue',
  'cyan',
  'green',
  'magenta',
  'purple',
  'red',
];

export const AVAILABLE_FIELD_OPTION_COLORS = AVAILABLE_SPACE_COLORS;

export const GanttBarColors: Color[] = [
  'blue',
  'green',
  'magenta',
  'cyan',
  'purple',
  'teal',
];

export enum StatusColors {
  Blocked = 'var(--red-60)',
  Cancelled = 'var(--cool-gray-40)',
  Completed = 'var(--green-40)',
  Default = 'var(--cool-gray-40)',
  InPlanning = 'var(--purple-60)',
  InProgress = 'var(--green-50)',
  Proposed = 'var(--blue-40)',
  ToBeStaffed = 'var(--orange-40)',
  ToDo = 'var(--blue-40)',
}

export const SmartFillTagColors = ALL_COLORS.filter(
  (_color) => !['blue', 'gray', 'cool-gray'].includes(_color),
);
